import { Navigate, useLocation } from 'react-router-dom';

import { useAnalytics } from '@eluve/posthog-react';

export const TenantToOrganizationRedirect = () => {
  const location = useLocation();
  const analytics = useAnalytics('tenant_to_organization_redirect');

  const newUrl =
    location.pathname.replace(/\/tenant/g, '/organization') +
    location.search +
    location.hash;

  analytics.capture('page_redirect', {
    from: location.pathname + location.search + location.hash,
    to: newUrl,
  });

  return <Navigate to={newUrl} replace={true} />;
};
